import React,{Component} from 'react';
import './style.scss'
import {Empty, Icon, Spin} from "antd";
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import LabelDropdown from "../../../../components/Dropdown/Dropdown/DrpDwn";
import moment from "moment";
import {Button} from "semantic-ui-react";
import Download from "../../../../components/Button/DownloadbleButton";
import {MDBDataTable} from "mdbreact";
import Cookies from "js-cookie";
import axiosTags from "../../../../axios/axios_tag";
import apiConfig from "../../../../axios/axios_api_services";
import * as common from "../../../../const/Common/CommonFunc";
let URL = (corp_id) => `https://us-east-1.quicksight.aws.amazon.com/embed/d67d1fc4907b4cb38ff0ada76bcdcc97/dashboards/31ed7f1b-14a9-407a-b646-afc03139065d?isauthcode=true&identityprovider=quicksight&code=AYABeNpZfw0S8UURnVyThZ6A0LgAAAABAAdhd3Mta21zAEthcm46YXdzOmttczp1cy1lYXN0LTE6MjU5NDgwNDYyMTMyOmtleS81NGYwMjdiYy03MDJhLTQxY2YtYmViNS0xNDViOTExNzFkYzMAuAECAQB4Q4pdZrmYHprS_1qu_Ad4K1Kwv7kyEcenFNvHMd9HVw8BWY7vvoIPb9GMh3P0jEZazQAAAH4wfAYJKoZIhvcNAQcGoG8wbQIBADBoBgkqhkiG9w0BBwEwHgYJYIZIAWUDBAEuMBEEDGMcO8LxBOnvUKmzXgIBEIA7HcX8ZPQmcRs4nqcaG2hg9JQ8pUeOThQWKY3qoYCX7qMAlUoQ334j7aHiPWpI5qEqICHiAG4jU11OUEMCAAAAAAwAABAAAAAAAAAAAAAAAAAAVHGGiiEqbZ2KrSUjQssYev____8AAAABAAAAAAAAAAAAAAABAAAAnloN4rOxv4ALJC8G_nBwRB64yPXkEjGEyz0BCYML8uosLWegHhUtPJjNdOTKHGB7nwzwpIKpbfgPQMO31xBdmJqWWrXbHliy7Det2T_4bpx8V6RTTCmMzMMErr646KvXOgyb2dh7M4K3-wEirGUCAdXY0b54aXAUJqIrO_3fWTpa6AhIG6JplBEBh42T74iK1zBizTwF6Af2CAmaGxxGYcHyU-2CyTVWtLTEjU__wA%3D%3D&byCorporate=${corp_id}`
class App extends Component {
  state = {
    spin: true,
    details: [],
    corporate_id: 0, tags_list: [], is_iframe: false, iframe_url: null
  };
  getAllDetails = () => {
    this.setState({spin: true});
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axiosTags.get(apiConfig.SERVICES, {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            details: response.data.body, spin: false
          });
          // this.filterHandler();
        } else {
          this.setState({details: [], spin: false})
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllDetails();
        }else{
          this.setState({details: [], spin: false})
        }
      });
  };

  componentDidMount() {
    this.getAllDetails();
  }
  titleOnChange = name => (e, {value}) => {
    this.setState({ is_iframe: false, iframe_url: null})
    if (name === 'corporate_id') {
      let tagServices = [];
      this.state.details.map((details, index) => {
        if (details.corporateId === value) {
          tagServices = details.services
        }
      });
      this.setState({
        [name]: value,
        tags_list: tagServices,
      });
    } else {
      this.setState({
        [name]: value
      });
    }
  };


  filterHandler = () => {
    let {corporate_id} = this.state;
    if(corporate_id) {
      // let generateURL = URL(corporate_id < 10 ? `87${corporate_id}567896`:`${corporate_id}0871567896`);
      // this.setState({ is_iframe: true,spin: true, iframe_url: generateURL})
      // window.location
      let corporateCode = corporate_id < 10 ? `87${corporate_id}567896`:`${corporate_id}0871567896`;
      let generateURL = URL(corporateCode);
      let token = generateURL.split("&code=")[1].split("&")[0];
      let existToken = localStorage.getItem('quicksight-id');
      if(existToken === null || token !== existToken) {
        localStorage.setItem('quicksight-id',token.toString());
      }else{
        generateURL = `https://us-east-1.quicksight.aws.amazon.com/embed/d67d1fc4907b4cb38ff0ada76bcdcc97/dashboards/31ed7f1b-14a9-407a-b646-afc03139065d?byCorporate=${corporateCode}`
      }
      window.open(generateURL, '_blank').focus();

    }else{
      common.notifyMessage("Please select a corporate");
    }
    // 871567896
    //
  }
  manageIframe = () => {
    this.setState({spin:false})
  };
  render() {
    let {is_iframe,iframe_url} = this.state;
    let corporate_options = [];
    if (this.state.details.length !== 0) {
      this.state.details.map((details, index) => {
        const obj = {
          key: details.corporateId,
          text: details.corporateName,
          value: details.corporateId
        };
        corporate_options.push(obj)
      })
    }
    return (
      <div className={'quicksight-user-report-wrapper'}>
        <Spin spinning={this.state.spin} delay={10}
              indicator={<Icon type="loading" style={{fontSize: 24}} spin/>}>
          <div>
            <Row>
              <Col xs={6}>
                <LabelDropdown
                  disabled={this.state.spin}
                  tagText={"Select Corporate"}
                  placeholder={"Select Corporate"}
                  options={corporate_options}
                  value={this.state.corporate_id}
                  onChange={this.titleOnChange("corporate_id")}
                />
              </Col>

              <Col xs={3}>
                <Button.Group className={"dual-btn-rangepicker-corp-sms-report"}>
                  <Button positive onClick={this.filterHandler}>Generate Report</Button>
                </Button.Group>
              </Col>
            </Row>
            {is_iframe ? <Row>
              <Col md={12}>
                <iframe src={iframe_url} className={"iframe-quick-sight iframe"} id={"iframe"}
                        onLoad={this.manageIframe}/>
              </Col>
            </Row>:null}

          </div>

        </Spin>
      </div>
    );
  }
}
export default App;
